import { render, staticRenderFns } from "./MenuPower.vue?vue&type=template&id=3e087f4b"
import script from "./MenuPower.vue?vue&type=script&lang=js"
export * from "./MenuPower.vue?vue&type=script&lang=js"
import style0 from "./MenuPower.vue?vue&type=style&index=0&id=3e087f4b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports